const themesulteng = {
    primary: '#015591',
    secondary: '#ffc900',
    btnprimary: '#015591',
};
export default themesulteng